<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <div class="search-holder search-holder-list">
          <div class="input-group">
            <input type="text" placeholder="Search by name, firm name, email or phone"
              @input="(e) => (bsTerm = e.target.value)" :value="bsTerm" class="search form-control"
              @keyup.enter="performBs" />
            <svg v-if="bsTerm" @click="resetBs" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001"
              style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14"
              class="close">
              <g>
                <g>
                  <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                  L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                  c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                  l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                  L284.286,256.002z" />
                </g>
              </g>
            </svg>
            <div class="input-group-append align-fix">
              <button class="btn btn-search" type="button" :disabled="!bsTerm" @click="performBs">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451"
                  style="enable-background: new 0 0 451 451" xml:space="preserve">
                  <g>
                    <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                           s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                           C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                           s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                  </g>
                </svg>
              </button>
              <a class="filter-menu btn btn-filter" @click="statusDialog = true">
                <img src="../../assets/filter-icon.svg" alt="PropertyPistol Syndicate Filter Menu" />
              </a>
            </div>
          </div>
        </div>
        <h2 class="title mt-4 mb-3">Assigned Brokers</h2>
        <div class="row">
          <div class="col-6">
            <span class="result-Text">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
          </div>
          <NCD searchKey="ncd" label="NCD" />
        </div>
        <div class="card-assigned-broker">
          <div class="card">
            <router-link :to="{ name: 'Broker', params: { id: broker.uuid } }" tag="div" class="card-body p-3"
              v-for="(broker, index) in brokers" :key="index">
              <div class="row">
                <div class="col-7 pr-0 mt-1">
                  <h3 class="broker-name">{{ broker.name }}</h3>
                  <span class="firm-name">{{ broker.firm_name }}</span>
                  <span class="mt-2 emp-Name" v-if="broker.user_name">
                    {{broker.user_name}}
                  </span>
                </div>
                <div class="col-5 pl-0 text-right">
                  <span class="label-status-sm">
                    {{ broker.status_name }}
                  </span>
                  <span class="date" v-if="broker.formatted_ncd">
                    <i class="icon-calender">
                      <img src="@/assets/calender.svg" alt="" />
                    </i>
                    {{ broker.formatted_ncd }}
                    <i class="icon-arrowr">
                      <img src="@/assets/right-arrow.svg" alt="" />
                    </i>
                  </span>

                </div>
              </div>
            </router-link>
          </div>
        </div>
      </b-container>

      <router-view></router-view>

      <vue-bottom-dialog v-model="filterStatus" :height="400">
        <div class="container-fluid">
          <div class="row">
            <div class="col-6">
              <h2 class="ml-2">Broker Status</h2>
            </div>
            <div class="col-6 text-right">
              <a class="outline-default mr-3"> Cancel </a>
              <a class="outline-default outline-default-primary"> Search </a>
            </div>
            <div class="col-12">
              <div class="wrapper-radio">
                <b-form-group>
                  <!-- <b-form-radio
                    v-for="status in statusList"
                    v-model="lead.status_id"
                    :key="`status${status.id}`"
                    name="some-radios"
                    :value="status.id"
                  >
                    {{ status.name }}
                  </b-form-radio> -->
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </vue-bottom-dialog>
      <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage"
        :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-item'" :prev-link-class="'page-link'"
        :next-class="'page-item'" :next-link-class="'page-link'" :container-class="'pagination justify-content-center'"
        :page-class="'page-item'" :page-link-class="'page-link'">
      </paginate>
    </div>
    <router-link :to="{ name: 'NewBroker' }" class="btn-float"><i class="icon-add">+</i></router-link>
    <vue-bottom-dialog v-model="statusDialog" :height="550">
      <div class="container-fluid">
        <b-tabs content-class="mt-3" justified>
          <b-tab title="Status" active>
            <div class="row mt-3">
              <div class="col-6">
                <h2 class="ml-2">Show Status</h2>
              </div>
              <div class="col-6 text-right">
                <a @click="cancelDialog()" class="outline-default mr-3">
                  Cancel
                </a>
                <a @click="filterBroker()" class="outline-default outline-default-primary">
                  Done
                </a>
              </div>
              <div class="col-12">
                <div class="wrapper-radio-empanelment-status">
                  <b-form-group>
                    <b-form-radio v-for="status in statusList" v-model="lead_statuses" :key="`status${status.id}`"
                      name="some-radios" :value="status.id">
                      {{ status.name }}
                    </b-form-radio>
                  </b-form-group>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Empanelment Date">
            <div class="row mt-3">
              <div class="col-6">
                <h2 class="ml-2">Select Range</h2>
              </div>
              <div class="col-6 text-right">
                <a @click="cancelDialog()" class="outline-default mr-3">
                  Cancel
                </a>
                <a @click="filterBroker()" class="outline-default outline-default-primary">
                  Done
                </a>
              </div>
              <div class="col-12">
                <div class="card mt-3">
                  <div class="card-header text-center p-0">
                    <b-tabs nav-class="calendar-tabs" justified>
                      <b-tab class="border-right" >
                        <template #title >
                          <span class="d-block">{{ startDateOutput }}
                            <img src="@/assets/caret.svg" alt="" /></span>
                        </template>
                        <div class="row">
                          <div class="col-12">
                            <div class="wrapper-radio-empanelment">
                              <b-form-group>
                                <b-calendar block v-model="startDateOutput" locale="en-US" placeholder="Start date" :hide-header="true">
                                </b-calendar>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template #title>
                          <span >{{ endDateOutput }}
                            <img src="@/assets/caret.svg" alt="" /></span>
                        </template>
                        <div class="row">
                          <div class="col-12">
                            <div class="wrapper-radio-empanelment">
                              <b-form-group>
                                <b-calendar block v-model="endDateOutput" locale="en-US" placeholder="Start date" :hide-header="true">
                                </b-calendar>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>


              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </vue-bottom-dialog>
  </div>
</template>

<script>
  import {
    paramsFromQuery
  } from "@/assets/scripts/utility.js";
  import qs from "qs";
  import NCD from "@/components/Common/Ncd.vue";
  export default {
    name: "Brokers",
    components: {
      NCD,
    },
    data() {
      return {
        showStart: false,
        showEnd: false,
        startDateOutput: "Start Date",
        endDateOutput: "End Date",
        brokers: [],
        filterStatus: false,
        bsTerm: this.$route.query.bs,
        total: 0,
        perPage: 0,
        statusDialog: false,
        lead_statuses: null,
      };
    },
    created() {
      this.fetchBrokerList();
    },
    watch: {
      $route(to, from) {
        this.fetchBrokerList();
      },
    },
    computed: {
      statusList() {
        return this.$store.getters.statusesMaster;
      },
      totalPages() {
        if (this.total === 0 || this.perPage === 0) {
          return 0;
        } else {
          return Math.ceil(this.total / this.perPage);
        }
      },
      pageNo: {
        get() {
          let pageNo = this.$route.query.pageNo || 1;
          return parseInt(pageNo);
        },
        set() {
          true;
        },
      },
      pageStart() {
        if (this.total === 0) {
          return 0;
        }
        return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
      },
      pageEnd() {
        if (this.total === 0) {
          return 0;
        }
        return Math.min(this.total, this.pageNo * this.perPage);
      },
    },
    methods: {
      resetBs() {
        let rQ = this.$route.query;
        this.bsTerm = "";
        if (rQ.bs) {
          let {
            bs,
            ...newQ
          } = rQ;
          this.$router.replace({
            query: newQ
          });
        }
      },
      performBs() {
        if (this.bsTerm) {
          let newQ = {
            ...this.$route.query,
            bs: this.bsTerm
          };
          delete newQ.pageNo;
          this.$router.replace({
            query: newQ
          });
        }
      },
      filterBroker() {
        let queryP = {
          ...this.$route.query,
          as: true,
          lead_statuses: this.lead_statuses,
        };
        if(this.startDateOutput != 'Start Date'){
          queryP["empanelment_done_from"] = this.startDateOutput
        }
        if(this.endDateOutput != 'End Date'){
          queryP["empanelment_done_to"] = this.endDateOutput
        }
        this.$router.replace({
          query: queryP
        });
        this.statusDialog = false;
      },
      cancelDialog() {
        this.statusDialog = false;
        this.lead_statuses = null;
        this.startDateOutput = "Start Date";
        this.endDateOutput = "End Date";
        let newQ = {
          ...this.$route.query,
          lead_statuses: this.lead_statuses
        };
        delete newQ.lead_statuses;
        delete newQ.empanelment_done_from;
        delete newQ.empanelment_done_to;
        delete newQ.as;
        delete newQ.pageNo;
        this.$router.replace({
          query: newQ
        });
      },
      fetchBrokerList() {
        let queryP = {};
        paramsFromQuery(queryP, this.$route.query);
        if (this.lead_statuses) {
          queryP["lead_statuses"] = this.lead_statuses;
        }
        if(this.startDateOutput != 'Start Date'){
          queryP["empanelment_done_from"] = this.startDateOutput
        }
        if(this.endDateOutput != 'End Date'){
          queryP["empanelment_done_to"] = this.endDateOutput
        }
        this.$axios
          .get("leads", {
            params: queryP,
            paramsSerializer: (params) =>
              qs.stringify(params, {
                arrayFormat: "brackets"
              }),
          })
          .then((res) => {
            this.brokers = res.data.leads;
            this.perPage = res.data.per_page;
            this.total = res.data.count;
          })
          .catch((err) => console.log(err));
      },
      goToPage(pageNo) {
        let newQ = {
          ...this.$route.query,
          pageNo
        };
        this.$router.replace({
          query: newQ
        });
      },
    },
  };
</script>
<style scoped>
</style>